import React, { useState } from 'react';
import { ReactComponent as XIcon } from 'assets/icons/ui-elements/small/x-mark-sm.svg';
import {
  ConfirmDeleteOverlay,
  ConfirmDeleteBox,
  ConfirmDeleteHeader,
  ConfirmDeleteTitle,
  ConfirmRestoreCloseButton,
  ConfirmRestoreCheckboxRow,
  ConfirmRestoreButton,
  OrangeCheckbox,
} from './styled';

interface ConfirmRestoreModalProps {
  isActioning: boolean;
  onConfirm: (excluirFotosAssinaturas: boolean) => void;
  onCancel: () => void;
}

export const ConfirmRestoreModal: React.FC<ConfirmRestoreModalProps> = ({ isActioning, onConfirm, onCancel }) => {
  const [excluirFotosAssinaturas, setExcluirFotosAssinaturas] = useState(false);

  return (
    <ConfirmDeleteOverlay onClick={onCancel}>
      <ConfirmDeleteBox onClick={(e: React.MouseEvent) => e.stopPropagation()}>
        <ConfirmDeleteHeader>
          <ConfirmDeleteTitle>Restaurar atividade</ConfirmDeleteTitle>
          <ConfirmRestoreCloseButton onClick={onCancel} aria-label="Fechar">
            <XIcon />
          </ConfirmRestoreCloseButton>
        </ConfirmDeleteHeader>

        <ConfirmRestoreCheckboxRow>
          <OrangeCheckbox
            id="excluir-fotos-assinaturas"
            checked={excluirFotosAssinaturas}
            onChange={e => setExcluirFotosAssinaturas(e.target.checked)}
          />
          <label htmlFor="excluir-fotos-assinaturas">
            Também excluir a assinatura e as fotos vinculadas à essa atividade.
          </label>
        </ConfirmRestoreCheckboxRow>

        <ConfirmRestoreButton type="button" onClick={() => onConfirm(excluirFotosAssinaturas)} disabled={isActioning}>
          {isActioning ? 'Aguarde...' : 'Restaurar'}
        </ConfirmRestoreButton>
      </ConfirmDeleteBox>
    </ConfirmDeleteOverlay>
  );
};
